export function getWorkingDaysOfMonth(year: number, month: number) {
  const firstDay = new Date(year, month - 1, 1)
  const lastDay = new Date(year, month, 0)

  let workingDays = 0
  
  for (let currentDay = firstDay; currentDay <= lastDay; currentDay.setDate(currentDay.getDate() + 1)) {
    if (isWorkingDay(currentDay)) {
      workingDays++
    }
  }

  return workingDays
}

function isWorkingDay(data: Date) {
  const dayWeek = data.getDay()
  return dayWeek !== 0 && dayWeek !== 6
}